import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import { api, fileUrl } from "@/lib/api";
import { FlagBanner, MapPin } from "@phosphor-icons/react";

export default function Finishers() {
  const [data, setData] = useState({ enabled: true, entries: [] });
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = eventId ? `?event_id=${eventId}` : "";
    api
      .get(`/finishers${q}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ enabled: true, entries: [] }))
      .finally(() => setLoading(false));
  }, [eventId]);

  const entries = data.entries || [];

  return (
    <div className="min-h-screen relative z-10">
      <Nav />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-testid="finishers-page">
        <div className="text-[10px] tracking-[0.3em] text-[#FF3B30] font-display">WALL OF FAME</div>
        <div className="flex items-baseline justify-between flex-wrap gap-4">
          <h1 className="font-display text-5xl mt-3">FINISHERS</h1>
          <select value={eventId} onChange={(e) => setEventId(e.target.value)} className="tactical-input max-w-[260px]" data-testid="finishers-event-filter">
            <option value="">All Events</option>
            {events.map((ev) => (
              <option key={ev.id} value={ev.id}>{ev.name}</option>
            ))}
          </select>
        </div>
        <p className="mt-3 text-sm text-white/50 max-w-xl">
          Selamat untuk para finisher! Setiap nama di bawah ini telah menyelesaikan larinya dan terverifikasi oleh tim kami.
        </p>

        {!data.enabled ? (
          <div className="mt-10 card-flat p-10 text-center text-white/50" data-testid="finishers-disabled">
            Finisher Wall sedang tidak aktif.
          </div>
        ) : loading ? (
          <div className="mt-10 text-white/50" data-testid="finishers-loading">Memuat...</div>
        ) : entries.length === 0 ? (
          <div className="mt-10 card-flat p-10 text-center text-white/50" data-testid="finishers-empty">
            Belum ada finisher. Jadilah yang pertama!
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="finishers-grid">
            {entries.map((e, i) => (
              <div key={`${e.bib_number}-${i}`} className="card-flat overflow-hidden fade-up" style={{ animationDelay: `${Math.min(i, 12) * 50}ms` }} data-testid={`finisher-card-${e.bib_number}`}>
                {e.finisher_photo_path ? (
                  <img src={fileUrl(e.finisher_photo_path)} alt={e.full_name} className="w-full aspect-square object-cover" data-testid={`finisher-photo-${e.bib_number}`} />
                ) : (
                  <div className="w-full aspect-square bg-[#0A0A0A] flex flex-col items-center justify-center border-b border-white/5">
                    <FlagBanner size={36} color="#FF3B30" weight="fill" />
                    <div className="font-mono-num text-3xl mt-3 text-white/80">#{e.bib_number}</div>
                  </div>
                )}
                <div className="p-3 md:p-4">
                  <div className="font-display tracking-wide text-sm md:text-base truncate">{e.full_name?.toUpperCase()}</div>
                  <div className="flex items-center gap-1 text-[11px] text-white/50 mt-1">
                    <MapPin size={12} className="shrink-0" />
                    <span className="truncate">{e.city || "-"}</span>
                  </div>
                  <div className="mt-2 text-[10px] text-[#FF3B30] tracking-widest truncate font-display">{e.event_name}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
